import { BitriseClientApi } from './api/bitriseApi.client.esm.js';
import { createApiRef, createPlugin, createApiFactory, discoveryApiRef, fetchApiRef } from '@backstage/core-plugin-api';

const bitriseApiRef = createApiRef({
  id: "plugin.bitrise.service"
});
const bitrisePlugin = createPlugin({
  id: "bitrise",
  apis: [
    createApiFactory({
      api: bitriseApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef
      },
      factory: ({ discoveryApi, fetchApi }) => {
        return new BitriseClientApi(discoveryApi, fetchApi);
      }
    })
  ]
});

export { bitriseApiRef, bitrisePlugin };
//# sourceMappingURL=plugin.esm.js.map
